import { call, put, takeLatest } from 'redux-saga/effects';
import { billingClient } from '../axios';
import { fetchSubscriptionFailure, fetchSubscriptionRequest, fetchSubscriptionSuccess } from './subscriptionSlice';

function* fetchSubscription() {
  try {
    const response = yield call(billingClient.get, '/subscriptions/current');
    yield put(fetchSubscriptionSuccess(response.data));
  } catch (error) {
    if (error.response?.status === 404) {
      yield put(fetchSubscriptionSuccess(null));

      return;
    }

    yield put(
      fetchSubscriptionFailure(
        error.response?.data?.errors?.message || error.message || 'Failed to fetch subscription',
      ),
    );
  }
}

export default function* subscriptionSaga() {
  yield takeLatest(fetchSubscriptionRequest.type, fetchSubscription);
}
